import {
  DashboardOutlined,
  PhoneOutlined,
  HistoryOutlined,
  UserOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'

export const anchorMenuItems: MenuProps['items'] = [
  {
    key: '/workspace',
    icon: <DashboardOutlined />,
    label: 'Workspace',
  },
  {
    key: '/calls/incoming',
    icon: <PhoneOutlined />,
    label: 'Incoming Calls',
  },
  {
    key: '/calls/history',
    icon: <HistoryOutlined />,
    label: 'Call History',
  },
  {
    key: '/profile',
    icon: <UserOutlined />,
    label: 'MEMBER CENTER',
  },
  {
    key: '/settings',
    icon: <SettingOutlined />,
    label: 'Settings',
  },
]
